import React from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { DataNode } from 'rc-tree/lib/interface';

import { LevelsInfo } from '../../../interfaces';
import { EditMultilevelCustomField } from '../../edit/EditMultilevelCustomField';

import PreviewWarningSection from './PreviewWarningSection';

type Props = {
    editedContextId: string;
    onClose: () => void;
    previewData: DataNode[];
    levelsInfo: LevelsInfo;
};

const PreviewConfigurationModal: React.FC<Props> = ({ onClose, editedContextId, previewData, levelsInfo }) => {
    return (
        <Modal
            onClose={onClose}
            autoFocus={false}
            shouldScrollInViewport={true}
        >
            <div>
                <ModalBody>
                    <PreviewWarningSection />
                    <EditMultilevelCustomField
                        isPreviewMode
                        previewData={previewData}
                        levelsInfoPreview={levelsInfo}
                        customFieldContextId={editedContextId}
                    />
                </ModalBody>
            </div>
            <ModalFooter>
                <ButtonGroup>
                    <Button
                        onClick={onClose}
                        appearance='subtle'
                    >
                        Close
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    );
};

export default PreviewConfigurationModal;
